import classes from './Cart.module.scss';
import DeleteCart from '../../../assets/icons/CrossChevron.svg';
import ColorNamer from 'color-namer';
import EmptyCart from '../../../assets/EmptyCart.png'
import { useEffect, useState } from 'react';
import { CartService } from '../../../services/CartService';
import { globalErrorHandler } from '../../../utils/errorHandler';
import { useLoader } from '../../../customHooks/loader';
import { toast } from 'react-toastify';
import { useCart } from '../../../customHooks/cart';
import { sumBy } from 'lodash-es';
import { useNavigate } from 'react-router-dom';

export const Cart = () => {

    const loader = useLoader();
    const cart = useCart();
    const navigate = useNavigate();
    const { removeFromCart } = cart();
    const [value, setValue] = useState(null)
    const [summary, setSummary] = useState({
        discount: 0,
        subTotal: 0,
        vat: 0
    })
    const [discountCoupon, setDiscountCoupon] = useState(null)
    const [cartProducts, setCartProducts] = useState(null);

    useEffect(() => {
        getCartSummary();
    }, []);

    useEffect(() => {
        const subTotal = sumBy(cartProducts, (product) => product.productPrice * product.quantity);
        const updatedSummary = { ...summary, subTotal };
        setSummary(updatedSummary);
    }, [cartProducts]);

    const getCartSummary = () => {
        CartService.getCartSummary(
            handleGetCartSummary,
            globalErrorHandler,
            loader
        )
    }

    const handleGetCartSummary = ({ data }) => {
        setCartProducts(data.data.cartSummary)
    }

    const updateItemQuantity = (skuId, quantity) => {
        const updatedCartProducts = cartProducts.map((item) => {
            if (item.skuId === skuId && quantity > 0 && quantity < item.qtyInStock) {
                return {
                    ...item,
                    quantity: quantity
                }
            } else if (item.skuId === skuId && quantity >= item.qtyInStock) {
                toast.error("Max allowed quantity, try again later");
                return item;
            } else {
                return item;
            }
        })

        setCartProducts(updatedCartProducts);
    }

    const deleteCartProduct = (skuId) => {
        // const updatedCartProducts = cartProducts.filter((item) => item.itemId !== itemId);
        // setCartProducts(updatedCartProducts);
        CartService.removeFromCart(
            { skuId, remark: "removedInCheckout" },
            handleRemoveFromCart,
            globalErrorHandler,
            loader
        );
    }

    const handleRemoveFromCart = ({ data }) => {
        console.log(data.data);
        removeFromCart(data.data.skuId);
        getCartSummary();
    }

    const onDiscountChange = event => setValue(event.target.value)

    const checkCoupon = (e) => {
        // add checks first
        setDiscountCoupon(value);
        const updatedSummary = { ...summary, discount: value ? 100 : 0 };
        setSummary(updatedSummary);
    }

    return (
        <div className={classes.CartContainer}>

            {cartProducts ?
                (cartProducts.length ?
                    <>
                        <div className={classes.NavHeader}>Shopping Bag</div>
                        <div className={classes.ShoppingBag}>
                            <table className={classes.CartTable}>
                                <tbody>
                                    <tr>
                                        <th style={{ width: "50%" }}>Items({cartProducts.length})</th>
                                        <th style={{ width: "15%" }}>Price</th>
                                        <th style={{ width: "15%", textAlign: "center" }}>Qty</th>
                                        <th style={{ width: "20%", textAlign: "center" }}>Total</th>
                                    </tr>
                                </tbody>

                                <tbody>
                                    {cartProducts.map((product) => (
                                        <>
                                            <tr className={classes.CartProduct}>
                                                <td className={classes.CartProductDetails}>
                                                    <img src={product.productImage} alt='product' />
                                                    <div className={classes.CartProductDescription}>
                                                        <div className={classes.CartItemName}>{product.productName}</div>
                                                        <div>
                                                            <span className={classes.Color}>Color: </span>
                                                            <span className={classes.ColorName}>{ColorNamer(product.color, { pick: ['ntc'] }).ntc[0].name}</span>
                                                            <div className={classes.ColorSample} style={{ backgroundColor: product.color }}></div>
                                                        </div>
                                                        <div>
                                                            <span className={classes.Color}>Size: </span>
                                                            <span className={classes.ColorName}>{String(product.sizes).toUpperCase()}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className={classes.CartProductPrice}>
                                                    <strong className={classes.CartProductPriceText}>{product.productPrice} د.إ AED</strong>
                                                </td>
                                                <td className={classes.CartProductQty}>
                                                    <div className={classes.CartProductQuantity}>
                                                        <div className={classes.CartProductQuantityControls} onClick={() => updateItemQuantity(product.skuId, product.quantity - 1)}>-</div>
                                                        <div className={classes.ItemQuantity}>{product.quantity}</div>
                                                        <div className={classes.CartProductQuantityControls} onClick={() => updateItemQuantity(product.skuId, product.quantity + 1, product.qtyInStock)}>+</div>
                                                    </div>
                                                </td>
                                                {/* <div className={classes.CartProductShippingPrice}>{product.shipping === 0 ? "FREE" : product.shipping}</div> */}
                                                <td className={classes.CartProductSubTotalPrice}>
                                                    <img onClick={() => deleteCartProduct(product.skuId)} className={classes.CartProductAction} src={DeleteCart} alt='delete from cart' />
                                                    <div>{(product.productPrice * product.quantity)} د.إ AED </div>
                                                </td>
                                            </tr>
                                            <tr style={{ height: "20px" }}></tr>
                                        </>
                                    ))}
                                </tbody>
                            </table>
                            <div className={classes.CartSummary}>
                                <div className={classes.CartSummaryHeader}>Order Summary</div>
                                <div>
                                    <span className={classes.Color}>SUBTOTAL: </span>
                                    <span className={classes.ColorName}>{summary.subTotal} د.إ AED</span>
                                </div>
                                <div>
                                    <span className={classes.Color}>VAT: </span>
                                    <span className={classes.ColorName}>{summary.vat} د.إ AED</span>
                                </div>
                                <div style={{ visibility: discountCoupon ? "visible" : "hidden" }}>
                                    <span className={classes.Color}>DISCOUNT: </span>
                                    <span className={classes.ColorName}>{summary.discount} د.إ AED</span>
                                </div>
                                <div className={classes.TotalPrice}>{(summary.subTotal + summary.vat) - summary.discount} د.إ AED</div>
                                <div className={classes.Checkout} onClick={() => navigate('/checkout', { state: cartProducts })}>Checkout</div>
                                <hr className={classes.PriceCheckoutDivider} />
                                <div className={classes.CartSummaryHeader} style={{ margin: "20px 0 16px" }}>Use Coupon Code</div>
                                <div className={classes.DiscountInput}>
                                    <input className={classes.DiscountInputField} type='text' value={value} onChange={onDiscountChange} />
                                    <div className={classes.ApplyDiscount} onClick={checkCoupon}>APPLY</div>
                                </div>
                            </div>
                        </div>
                    </> :
                    <div className={classes.EmptyCart}>
                        <img src={EmptyCart} className={classes.EmptyCartImage} alt='cart is empty' />
                        <div className={classes.EmptyCartTitle}>Your cart is empty and sad :&#40;</div>
                        <div className={classes.EmptyCartSubTitle}>Add something to make it happy!</div>
                        <div className={classes.EmptyCartContinueShopping}>Continue Shopping</div>
                    </div>
                ) :
                null
            }
        </div>
    );
}